export default {
	title: 'Objednávka',
	availableContacts: 'K dispozici kontaktů',
	zipCode: 'PSČ',
	yourOrder: 'Vaše objednávka',
	totalOrder: 'Celkem k objednání',
	pieces: 'Ks',
};
